import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterKorat extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>AIKIDO KORAT's MEMBERS</h3>
      <br />
      <br />

        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterKorat;
